/* src/app/components/sidebar/sidebar.component.scss */
* {
  margin: 0;
  padding: 0;
}
:host {
  height: 100%;
}
.header-md::after {
  background: none;
}
ion-item,
ion-list,
ion-content {
  color: var(--ion-color-primary) !important;
}
ion-item,
ion-accordion ion-label {
  color: var(--ion-color-primary);
}
ion-accordion div ion-item {
  padding-left: 1.5rem;
}
ion-item.selected {
  background: rgba(211, 211, 211, 0.1);
}
ion-item:hover {
  --background: rgba(lightgray, 0.1);
  --color-hover: var(--ion-color-primary);
}
ion-label {
  font-size: 15px !important;
  font-weight: bold;
}
ion-item:focus,
ion-item:focus-within {
  outline: 2px solid var(--ion-color-primary);
}
/*# sourceMappingURL=sidebar.component.css.map */
